import { Progress } from "semantic-ui-react";
import { isUndefined } from "../../../libs/common_utils";

const LegendBar = ({ color = "#21ba45", progress }) => {
  if (isUndefined(progress))
    return (
      <span
        style={{
          display: "inline-block",
          width: 16,
          height: 8,
          borderRadius: 2,
          background: color,
          marginRight: 8,
          verticalAlign: "middle",
        }}
      />
    );

  return (
    <Progress
      percent={progress}
      size="tiny"
      style={{
        width: 16,
        height: 8,
        marginBottom: 0,
        marginRight: 8,
        verticalAlign: "middle",
      }}
      color={color}
    />
  );
};

export default LegendBar;
